import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { apiPath } from '../config/apiBase';
import './Login.css';

const getDashboardPath = (role) => {
  switch (role) {
    case 'admin':
      return '/admin';
    case 'maitresse':
      return '/maitresse';
    case 'donateur':
      return '/donateur';
    default:
      return '/operateur';
  }
};

const Login = () => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.setAttribute('dir', 'ltr');
    document.documentElement.setAttribute('lang', 'fr');
    void i18n.changeLanguage('fr');
  }, [i18n]);

  useEffect(() => {
    if (authLoading || !user) return;
    navigate(getDashboardPath(user.role), { replace: true });
  }, [user, authLoading, navigate]);

  useEffect(() => {
    void import('../pages/AdminDashboard').catch(() => {});
    void import('../pages/OperateurDashboard').catch(() => {});
    // Réveille Laravel avant la soumission (évite ~2–3 s au 1er login)
    fetch(apiPath('/public/site-settings'), { credentials: 'same-origin' }).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(email, password);

      if (result.success) {
        navigate(getDashboardPath(result.user.role));
      } else {
        setError(result.error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Khayr</h1>
        <h2>{t('common.login')}</h2>
        <form onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label>{t('common.email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>{t('common.password')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? t('common.signingIn') : t('common.signIn')}
          </button>
        </form>
        <div className="login-info">
          <p><strong>Compte Admin:</strong> admin@khayr.com / password</p>
          <p><strong>Compte Opérateur:</strong> operateur@khayr.com / password</p>
          <p><strong>Compte Maîtresse:</strong> maitresse@khayr.com / password</p>
        </div>
      </div>
    </div>
  );
};

export default Login;



